<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
const props = defineProps({
  createSteps: {
    type: Array,
    required: true,
  },
  createStep: {
    type: String,
    required: true,
  },
  createStepIndex: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['goToStep']);

const canOpenStep = index => index <= props.createStepIndex;
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <ol class="m-0 grid list-none gap-2 p-0 sm:grid-cols-4">
    <li
      v-for="(step, index) in props.createSteps"
      :key="step.value"
      class="list-none"
    >
      <button
        type="button"
        class="flex h-full w-full items-center gap-2 rounded-lais border px-3 py-2 text-left text-[13px] font-semibold transition-colors"
        :class="
          props.createStep === step.value
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
            : index < props.createStepIndex
              ? 'border-lais-border bg-white text-lais-text'
              : 'cursor-not-allowed border-lais-border bg-white text-lais-text-muted opacity-70'
        "
        :disabled="!canOpenStep(index)"
        :aria-disabled="String(!canOpenStep(index))"
        :aria-current="props.createStep === step.value ? 'step' : null"
        @click="emit('goToStep', step.value)"
      >
        <span
          class="grid size-6 shrink-0 place-items-center rounded-full text-[12px]"
          :class="
            index <= props.createStepIndex
              ? 'bg-lais-primary text-white'
              : 'bg-lais-bg-soft text-lais-text-muted'
          "
        >
          {{ index + 1 }}
        </span>
        {{ step.label }}
      </button>
    </li>
  </ol>
</template>
